import { connect } from 'react-redux';

import * as api from '../../api';
import * as Practice from '../../utils/practice';

import { All } from '../../reducers/store';

import styles from './index.module.css';

interface StateProps {
  theme: api.PracticeTheme.ThemeResponse | null;
}

interface Props extends StateProps {}

const Logo: React.FC<Props> = ({ theme }) => {
  const { logoUrl } = Practice.getCustomer();
  const altContent = theme ? `${theme.organizationName} logo` : 'logo';

  return (
    <>
      <img
        className={styles.Logo}
        src={theme?.previsitLogoUrl || logoUrl}
        alt={altContent}
      />
    </>
  );
};

const mapStateToProps = (store: All): StateProps => ({ theme: store.theme });

export default connect(mapStateToProps)(Logo);
